// extracted by mini-css-extract-plugin
export default {"variants":"YmOjTm","label":"UgvUOV","BoxSelectionOption":"sxdjNC","boxSelectionOption":"sxdjNC"};